const prefix = '/auth';
const Routes = {
  Auth: prefix,
  Login: prefix + '/login',
  Register: prefix + '/register',
  RequestPasswordReset: prefix + '/request-password-reset',
  ResetPassword: prefix + '/reset-password',
  CompleteRegistration: prefix + '/complete-registration',
  VerifyEmail: prefix + '/verify-email',
};

export default Routes;
